module.exports = __webpack_public_path__ + "media/images/brand/facebook-d20bc5c90047f5abd40dfdbe9d2149d2.svg";